export enum ServiceVisibilityType {
  ALL = "ALL",
  NEW = "NEW",
  EXISTING = "EXISTING",
  NO_PATIENTS = "NO",
}
